import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';

const ALL_CARDS: (HubCardItem & { referentFunction?: string })[] = [
  { to: '/panel/moderation', title: 'File modération', description: 'Signalements et sanctions joueurs.', accent: 'amber' },
  { to: '/panel/users-roles', title: 'Liste & surveillance', description: 'Joueurs en ligne, détails, sanctions quotidiennes.', accent: 'sky' },
  { to: '/panel/security', title: 'Logs & traçabilité', description: 'Vue synthétique sécurité.', accent: 'emerald' },
  {
    to: '/panel/system/security-logs',
    title: 'Logs complets (Réf. Modo)',
    description: 'Événements auth détaillés — fonction Référent Modo.',
    accent: 'emerald',
    referentFunction: 'Référent Modo',
  },
];

const PanelModoHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();
  const roleId = currentUser?.roles_id ?? 0;
  const canEnterHub = hasAccessToSection('salon_modo');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  const cards = useMemo(() => {
    return ALL_CARDS.filter((c) => {
      if (c.referentFunction) {
        if (roleId === 1) return true; // CM voit tout
        return hasReferentFunction(c.referentFunction);
      }
      return true;
    });
  }, [hasReferentFunction, roleId]);

  if (!currentUser || loading || !canEnterHub) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Modération et surveillance des joueurs. Pas d’accès premium, économie, scénarios ni outils système CM."
      cards={cards}
    />
  );
};

export default PanelModoHubV1;
